import { useContext, useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { calculateWordsFromString, dateConvert } from "../../../utils/Helper";

export const useVpnRequest = ({ setShowRequestPopup, callApi, editData, projectOpts }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [vpnRequestData, setVpnRequestData] = useState({});
    const [approveBy, setApproveBy] = useState([]);
    const [previousData, setPreviousData] = useState({});
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        if (editData !== undefined && editData !== null) {
            const data = {
                "vpn_request_id": editData?.vpn_request_id,
                "project_id": _.findWhere(projectOpts, { project_id: editData?.project_id }),
                "is_prod": editData?.is_prod ? "1" : "0",
                "from_date": new Date(editData?.from_date),
                "to_date": new Date(editData?.to_date),
                "reason": editData?.reason,
                "approver_user_code": editData?.approver_user_code
            }
            setVpnRequestData(data)
            GetVpnRequestApprover(editData?.project_id, editData?.is_prod ? "1" : "0")
            setPreviousData(data)
        } else {
            setVpnRequestData({
                vpn_request_id: 0,
                "project_id": 0,
                "is_prod": '',
                "from_date": new Date(),
                "to_date": "",
                "reason": "",
                "approver_user_code": 0
            });
        }
    }, [editData])


    const handleChange = (e, check) => {
        const { name, value } = e.target
        if (check) {
            name === "is_prod" && GetVpnRequestApprover(vpnRequestData?.project_id?.project_id, value)
            setVpnRequestData((prev) => ({ ...prev, [name]: value, approver_user_code: '' }))
        } else if (name === "project_id") {
            GetVpnRequestApprover(value?.project_id,vpnRequestData?.is_prod)
            setVpnRequestData((prev) => ({ ...prev, [name]: value, "approver_user_code": '' }))
        } else if (name === "from_date") {
            setVpnRequestData((prev) => ({ ...prev, [name]: value, to_date: "" }))
        } else {
            setVpnRequestData((prev) => ({ ...prev, [name]: value }))
        }
    }


    const GetVpnRequestApprover = async (project_id, is_prod) => {
        const payload = {
            "is_prod": is_prod === "1" ? true : false,
            "project_id": project_id ? project_id : vpnRequestData?.project_id?.project_id
        }
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETVPNREQUESTAPPROVER"), payload);
            if (res?.body?.data?.approver_list) {
                setApproveBy(res?.body?.data?.approver_list)
            }
        } catch (error) {
            showError('Error', error?.response?.data?.errorMessage);
            console.error("Error:", error);
        }
    }

    const vpnRequestUpsert = async () => {
        if (_.isEqual(vpnRequestData, previousData)) {
            showInfo("info", "No changes made");
            return;
        }
        if (vpnRequestData?.project_id === 0) {
            showInfo("info", "Please select project.");
            return;
        }
        if (!vpnRequestData?.is_prod) {
            showInfo("info", "Please select an env");
            return;
        }
        if (!vpnRequestData?.from_date) {
            showInfo("info", "Please select an from date");
            return;
        }
        if (!vpnRequestData?.to_date) {
            showInfo("info", "Please select an to date");
            return;
        }
        if (vpnRequestData?.approver_user_code === 0 || vpnRequestData?.approver_user_code === "") {
            showInfo("info", "Please select an approver");
            return;
        }
        if (calculateWordsFromString(vpnRequestData.reason) < 5) {
            showInfo("info", "Reason should contain minimum 5 words");
            return;
        }
        const payload = {
            "vpn_request_id": vpnRequestData?.vpn_request_id,
            "project_id": vpnRequestData?.project_id?.project_id,
            "is_prod": vpnRequestData?.is_prod === "1" ? true : false,
            "from_date": dateConvert(vpnRequestData?.from_date, 'iso-string'),
            "to_date": dateConvert(vpnRequestData?.to_date, 'iso-string'),
            "reason": vpnRequestData?.reason,
            "approver_user_code": vpnRequestData?.approver_user_code
        }
        try {
            setLoader(true)
            const res = await services.getInvokeRemote("POST", Urls("VPNREQUESTUPSERT"), payload);
            if (!res?.body?.error_status) {
                setLoader(false)
                showSuccess("success", res?.body?.message);
                callApi();
                setShowRequestPopup(false);
                setVpnRequestData({
                    vpn_request_id: 0,
                    "project_id": 0,
                    "is_prod": '',
                    "from_date": new Date(),
                    "to_date": "",
                    "reason": "",
                    "approver_user_code": 0
                });
            } else {
                setLoader(false)
                showError("error", res?.body?.errorMessage);
                return;
            }
        } catch (error) {
            setLoader(false)
            showError('Error', error?.response?.data?.errorMessage);
            console.error("Error:", error);
        }
    }

    return useMemo(() => ({
        vpnRequestUpsert, handleChange, vpnRequestData, approveBy, loader
    }), [vpnRequestUpsert, handleChange, vpnRequestData, approveBy, loader]);
}